import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {RouterModule, Routes} from '@angular/router';
import {CardModule, PaginationModule, SliderModule, SubscriptionFormModule} from '../../shared/components';
import {FileModule} from '../../shared/pipes';
import {NewsPagesComponent} from './news-pages.component';
import {NewsPageComponent} from './news-page/news-page.component';
import {ParagraphComponent} from './news-page/paragraph/paragraph.component';
import {ImageComponent} from './news-page/image/image.component';
import {VideoComponent} from './news-page/video/video.component';
import {LinkButtonComponent} from './news-page/link-button/link-button.component';
import {FileDownloadComponent} from './news-page/file-download/file-download.component';
import {QuoteComponent} from './news-page/quote/quote.component';
import {TranslateModule} from '@ngx-translate/core';
import {FilePipe} from '../../shared/pipes/file/file.pipe';

const routes: Routes = [
  {path: '', component: NewsPagesComponent},
  {path: ':id', component: NewsPageComponent},
];

@NgModule({
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    CardModule,
    PaginationModule,
    FileModule,
    TranslateModule,
    SubscriptionFormModule,
    SliderModule
  ],
  declarations: [
    NewsPagesComponent,
    NewsPageComponent,
    ParagraphComponent,
    ImageComponent,
    VideoComponent,
    LinkButtonComponent,
    FileDownloadComponent,
    QuoteComponent
  ],
  providers: [
    FilePipe
  ]
})
export class NewsPagesModule {
}
